export const blueSkiesStyles = {
  image: {
    titleTransparent: process.env.REACT_APP_HEADER_IMAGE,
    title: process.env.REACT_APP_HEADER_IMAGE,
    donateCTA: 'blue-skies-donate-cta.png',
  },
  font: {
    heading: 'Cheddar Gothic Sans',
    subheading: 'Glacial Indifference',
    paragraph: 'PT Sans, sans-serif',
    subheadingWeight: 'bold',
    subheadingTransform: 'uppercase',
  },
  strings: {
    title: 'Great American Debate',
  },
  color: {
    text: '#1c4c6c',
    background: 'rgb(188, 217, 240)',
    shadow: 'rgba(104, 166, 214, 1)',
  },
  layout: {
    background: 'radial-gradient(circle, rgba(188, 217, 240, 1) 0%, rgba(104, 166, 214, 1) 100%)',
  },
}
